import React from "react";
import ErrorsHistory from "../../components/ErrorsHistory";

const ErrorsHistoryScreen = () => {
  return <ErrorsHistory />;
};

export default ErrorsHistoryScreen;
